import React from 'react';
import './Contact.css';
import qrCode from '../../assets/images/qr-code-che3.png';

const Contact = () => {
  const socialLinks = [
    {
      name: 'Dribbble',
      icon: 'fab fa-dribbble',
      url: 'https://dribbble.com'
    },
    {
      name: 'Facebook',
      icon: 'fab fa-facebook',
      url: 'https://facebook.com'
    },
    {
      name: 'Email',
      icon: 'fas fa-envelope',
      url: 'mailto:mirat7932@mail.ru'
    },
    {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin',
      url: 'https://linkedin.com'
    }
  ];

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="contact__content">
          <div className="contact__info">
            <div className="contact-card card">
              <div className="contact-card__divider"></div>
              <h3 className="contact-card__title">Контакты</h3>
              
              <div className="contact-card__item">
                <div className="contact-card__phone">+7 (987) 481-79-32</div>
                <div className="contact-card__label">телефон, whatsapp</div>
              </div>

              <div className="contact-card__item">
                <div className="contact-card__email">mirat7932@mail.ru</div>
                <div className="contact-card__label">электронная почта</div>
              </div>

              <div className="contact-card__item">
                <div className="contact-card__address">Самовывоз из офиса на Чехова 2А</div>
                <div className="contact-card__delivery">Действует доставка по Челябинску</div>
              </div>

              <div className="contact-card__social">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.url} 
                    className="social-link" 
                    aria-label={social.name}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className={social.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="contact__qr">
            <img src={qrCode} alt="QR код" className="contact__qr-image" />
          </div>

          <div className="contact__footer">
            <div className="footer-heart">
              <i className="fas fa-heart"></i>
            </div>
            <div className="footer-text">С заботой к клиенту!</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;